@if (error()) {
  <cmt-error-state
    title="Service Management Tool unavailable"
    message="The Service Management Tool could not be loaded."
    hint="Please try again. If the problem persists, contact your IT team."
    retryLabel="Reload SMT"
    (retry)="retry()"
  />
} @else {
  <!-- Full-bleed embed at a FIXED height, with SMT's own scrollbar left on. Auto-height
       was reverted: SMT posts its height exactly once per load and never again, so sizing
       the frame to it broke in both directions once its content changed — long lists
       became unreachable and a save left the page scrolled into empty space. Old CMT
       never asked for a height either (`service.management.tool.html:4-7`, 85vh).
       All three claims in this comment were stale (PR #42 review, roundup #10). -->
  <div class="relative min-h-[520px] w-full">
    @if (!ready()) {
      <div class="absolute inset-0 z-10 grid place-items-center bg-card">
        <div class="flex flex-col items-center gap-3 text-muted-foreground">
          <hlm-spinner size="28" />
          <p class="text-sm">Loading Service Management Tool…</p>
        </div>
      </div>
    }

    <iframe
      #smtFrame
      title="Service Management Tool"
      [src]="iframeSrc()"
      [style.height]="iframeHeight()"
      [attr.scrolling]="iframeScrolling()"
      class="block w-full border-0"
      (error)="onIframeError()"
    ></iframe>
  </div>
}
